import {ServiceBase} from "../ServiceBase";
import {ILoyaltyService} from "./loyalty-indicator.service.interface"
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {ILoyaltyIndicatorViewModel} from "./models/loyalty-indicator-view-model.interface";
import {LoyaltyIndicatorModel} from "./models/loyalty-indicator.model";
import {Nullable} from "../../../common/types/nullable-types";
import {Check} from "@sparkware/app-utils";

export class LoyaltyService extends ServiceBase implements ILoyaltyService {
    constructor(services: IServiceFactoryExtended) {
        super(services);

        this.reaction(() => this.services.user.isAuthorized,
            (isAuthorized) => {
                if (!isAuthorized) {
                    if (this._loadLoyaltyPromise) {
                        this._loadLoyaltyPromise.then(model => {
                            model.dispose();
                        });
                        this._loadLoyaltyPromise = null;
                    }
                }
            }
        )
    }

    private _loadLoyaltyPromise: Nullable<Promise<ILoyaltyIndicatorViewModel>> = null;
    async init(): Promise<void> {
        if (this._loadLoyaltyPromise) {
            return;
        }

        this._loadLoyaltyPromise = this._loadLoyalty();
        
        // clear cache promise
        this._loadLoyaltyPromise.catch((err) => {
            this._loadLoyaltyPromise = null;
            throw err;
        });
    }

    private async _loadLoyalty() {
        await this._loadLoyaltyScript();
        const fireBaseToken = await this.services.firebase.getToken();
        const platformToken = await this.services.user.getPlatformToken();

        return new LoyaltyIndicatorModel(this.services, {
            platformToken: platformToken,
            firebaseToken: fireBaseToken,
        });
    }

    private _loadLoyaltyScriptPromise: Nullable<Promise<void>> = null;
    private _loadLoyaltyScript(): Promise<void> {
        if (!this._loadLoyaltyScriptPromise) {
            if(Check.isEmpty(this.services.configuration.servicesConfigs.Loyalty.scriptLink)){
                return Promise.reject("Loyalty script link is empty");
            }
            this._loadLoyaltyScriptPromise = this.services.scriptLoader.loadScript({
                url: this.services.configuration.servicesConfigs.Loyalty.scriptLink
            }).catch(err => {
                this.services.logger.error(`Failed to load loyalty script`, err);
                this._loadLoyaltyScriptPromise = null;
                throw err;
            });
        }

        return this._loadLoyaltyScriptPromise;
    }


}